import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

const AttributeGroupList = ({ attributeGroups, onEdit, onDelete }) => (
	<table className="table table-striped">
		<thead>
			<tr>
				<th>Name</th>
				<th>Type</th>
				<th colSpan="2">Visit Fee</th>
			</tr>
		</thead>
		<tbody>
			{attributeGroups.length === 0 ? (
				<tr>
					<td colSpan="3">No records found</td>
				</tr>
			) : (
				attributeGroups.map(attributeGroup => (
					<tr key={`${attributeGroup.id}`}>
						<td>{attributeGroup.program_name}</td>
						<td>{attributeGroup.program_type}</td>
						<td>${numeral(attributeGroup.patient_evisit_cost).format('0.00')}</td>
						<td className="text-right">
							<button
								className="btn btn-default edit"
								onClick={() => onEdit(attributeGroup)}
							>
								<em className="fa fa-pencil" />
							</button>
							<button
								className="btn btn-danger delete"
								onClick={() => onDelete(attributeGroup)}
							>
								<em className="fa fa-remove" />
							</button>
						</td>
					</tr>
				))
			)}
		</tbody>
	</table>
);

AttributeGroupList.propTypes = {
	attributeGroups: PropTypes.array.isRequired,
	onEdit: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired
};

export default AttributeGroupList;
